import {
  CheckListsProvider,
  useChecklistsContext,
} from "src/components/pages/Settings/Miscellaneous/CheckLists/CheckListsContext";
import CheckListsHeader from "src/components/pages/Settings/Miscellaneous/CheckLists/CheckListsHeader";
import CheckListTable from "src/components/pages/Settings/Miscellaneous/CheckLists/CheckListTable/CheckListTable";
import { PageContainer } from "src/styled";

const ChecklistLogbook = () => {
  return (
    <CheckListsProvider>
      <PageContainer>
        <CheckListsHeader />
        <CheckListTable />
      </PageContainer>
    </CheckListsProvider>
  );
};

export default ChecklistLogbook;
